.nav {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  min-width: 0;
}

/* Stage-sized: set navigation is tapped mid-song on a tablet on a music stand (48–52px) */
.target {
  min-height: 52px;
  min-width: var(--tuna-spacing-6);
  text-transform: none;
  border-radius: var(--tuna-shape-radius-md);
}

.previous,
.next {
  justify-content: space-between;
  text-align: left;
  min-width: 0;
}

.previous {
  max-width: 14rem;
}

/* The one raised button: the next song is what the performer reaches for */
.next {
  max-width: 18rem;
  background-color: var(--tuna-palette-action-selected);
}

/* On the overview: the primary action, filled with the accent */
.start {
  background-color: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
}

.startCaption {
  font-size: var(--tuna-typography-fontSize-xs);
}

.position {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.stack {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.caption,
.name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.caption {
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-content-secondary);
}

.name {
  font-weight: 600;
}

/* Phones: ‹ n / N ›, 48px targets in a 68px bar */
.compact {
  gap: 2px;
}

.compact .target {
  min-height: var(--tuna-spacing-6);
}

.compact .start {
  max-width: 14rem;
}

.menuItem {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
}
